export class sessionService {
  /* @ngInject */
  constructor (appSettings) {
    this.appSettings = appSettings
  }
  async getDeviceAuthSessionData() {
    if (this.hasOwnProperty('sessionAccessInfo'))
      return Promise.resolve(this.sessionAccessInfo)
    try {

      const resultArray = await Promise.all([this.getSessionInfo(), this.getAccessInfo()])

      var username = this.parseSessionInfo(resultArray[0])
      var accessParams = resultArray[1].returnValue

      if (username === null || username == '')
        return null

      if (accessParams == '/' || accessParams == '')
        return null

      this.sessionAccessInfo = { username, accessParams}

      return this.sessionAccessInfo
    } catch (e) {
      //console.log('Xerox SSO unavailable')
      return null
    }
  }
  getSessionInfo() {
    return new Promise((resolve, reject) => {
      xrxSessionGetSessionInfo(
        this.appSettings.deviceUrl,
        (env, response) => resolve(response),
        (request, response, status) => reject({request, response, status}) // TODO: handle error
      )
    })
  }
  parseSessionInfo(sessionInfo) {
    const parsedInfo = xrxSessionParseGetSessionInfo(sessionInfo)
    return xrxGetElementValue(parsedInfo, 'username')
  }
  getAccessInfo() {
    return new Promise((resolve, reject) => {
      xrxWsSnmpGet(
        this.appSettings.deviceUrl,
        'public',
        '1.3.6.1.4.1.253.8.74.6.2.1.9.06.157.118.300',
        (env, response) => resolve(xrxWsSnmpParseGet(response)),
        (request, response, status) => reject({request, response, status}) // TODO: handle error
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/session.service.js